
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[slug]",
      function () {
        return require("private-next-pages/profile/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/[slug]"])
      });
    }
  